import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {TableWrapper} from 'shells/dashboard/table/table-wrapper';
// @ts-expect-error - imported from .js/.jsx file
import {SortDownIcon} from 'shells/icon/svg/sort-down-icon';
import {Link} from 'shells/link/link';
import {FormattedTimestamp} from 'shells/timestamp/formatted-timestamp';

import type {EditionDashboardFragment as Edition} from 'nutshell-graphql-types';

import {getEditionsTableEmptyStateTitle} from './helpers';

type Props = {
    editions: Edition[];
    timespan: string;
};

export function EditionsTable(props: Props) {
    const columns = React.useMemo(
        () => [
            {
                id: 'title',
                Header: 'Recently sent',
                accessor: (row: Edition) => row,
                dataType: 'linkedName',
                width: 200,
                shouldTruncate: true,
                titleKey: 'name',
            },
            {
                id: 'createdTime',
                Header: (
                    <div className='flex align-center gap-8'>
                        <SortDownIcon size={14} alignCenter={true} />
                        Date
                    </div>
                ),
                accessor: (row: Edition) => row.scheduledTime,
                dataType: 'component',
                width: 120,
                maxWidth: 120,
                minWidth: 120,
                rightAlign: true,
                Cell: ({cell}: any) => {
                    const {value} = cell;

                    return (
                        <FormattedTimestamp
                            format={FormattedTimestamp.formats.shortMonthDay}
                            datetime={value}
                        />
                    );
                },
            },
            {
                id: 'deliveryCount',
                Header: 'Deliveries',
                accessor: (row: Edition) => row.engagementStats.totalSentCountFormatted,
                dataType: 'integer',
                width: 100,
            },
            {
                id: 'openRate',
                Header: 'Open rate',
                accessor: (row: Edition) => row.engagementStats.openRateFormatted,
                dataType: 'percentage',
                width: 100,
            },
            {
                id: 'clickRate',
                Header: 'Click rate',
                accessor: (row: Edition) => row.engagementStats.clickRateFormatted,
                dataType: 'percentage',
                width: 100,
            },
        ],
        []
    );

    const title = getEditionsTableEmptyStateTitle(props.timespan);

    return (
        <TableWrapper
            columns={columns}
            items={props.editions}
            isLoading={false}
            error={null}
            emptyStateProps={{
                title,
                subtitle: 'Your most recent emails will appear here',
                cta: (
                    <Link
                        // @ts-expect-error
                        as={RoutedLink}
                        variant='button'
                        size='big'
                        to='/email-marketing/broadcasts'
                    >
                        Create a broadcast
                    </Link>
                ),
            }}
        />
    );
}
